import { fetchWithAuth } from '../pages/authService';
import { API_ENDPOINTS } from './constants';

export const fetchTrendingSongs = async token => {
  try {
    const response = await fetchWithAuth(API_ENDPOINTS.TRACK_TRENDING, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch trending songs');

    const data = await response.json();
    localStorage.setItem('trendingsongs', JSON.stringify(data));
    return data;
  } catch (error) {
    console.error('Error fetching trending songs:', error);
    throw error;
  }
};

export const fetchArtists = async token => {
  try {
    const response = await fetchWithAuth(API_ENDPOINTS.ARTISTS, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch artists');

    const data = await response.json();
    const artists = data.artists;
    localStorage.setItem('artists', JSON.stringify(artists));
    return artists;
  } catch (error) {
    console.error('Error fetching artists:', error);
    throw error;
  }
};

export const fetchLanguages = async token => {
  try {
    const response = await fetchWithAuth(API_ENDPOINTS.LANGUAGES, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch languages');

    const data = await response.json();
    const languages = data.languages;
    localStorage.setItem('languages', JSON.stringify(languages));
    return languages;
  } catch (error) {
    console.error('Error fetching languages:', error);
    throw error;
  }
};

export const fetchPlaylists = async token => {
  try {
    const response = await fetchWithAuth(API_ENDPOINTS.PLAYLISTS, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to fetch playlists');

    const playlists = await response.json();

    // Fetch songs for each playlist
    const updatedPlaylists = await Promise.all(
      playlists.map(async playlist => {
        const songsResponse = await fetchWithAuth(
          API_ENDPOINTS.PLAYLIST_TRACKS(playlist.id),
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!songsResponse.ok) {
          console.error(`Failed to fetch songs for playlist ${playlist.id}`);
          return { ...playlist, songs: [] };
        }

        const songs =
          songsResponse.status === 204 ? [] : await songsResponse.json();
        return { ...playlist, songs };
      })
    );

    localStorage.setItem('playlists', JSON.stringify(updatedPlaylists));
    return updatedPlaylists;
  } catch (error) {
    console.error('Error fetching playlists:', error);
    throw error;
  }
};
